import React, { useState } from 'react';
import './MobileNavbar.css';
import Logo from './assets/download.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { getState } from './Firebase/auth';
import { motion, useScroll, useTransform, cubicBezier, useSpring } from 'framer-motion';
import { ShoppingBag, User, LogIn } from 'lucide-react';

export default function MobileNavBar({ sidebar, setSideBar, footerLogoOpacity }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { scrollY } = useScroll();
  const smoothScrollY = useSpring(scrollY, { damping: 20, stiffness: 90 });
  const logoScale = useTransform(smoothScrollY, [0, 220], [1, 0.62]);
  const logoY = useTransform(smoothScrollY, [0, 300], ['10vh', '0vh']);
  const contentOpacity = useTransform(smoothScrollY, [0, 100], [0, 1]);
  const isHome = location.pathname === '/';

  const accountClick = () => {
    if (getState()) {
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  const toggleMobileMenu = () => {
    setSideBar(!sidebar);
  };

  return (
    <div className="MobileNavBar">
      <div className="nav-mobile-header">
        <motion.button onClick={toggleMobileMenu} className="burger-button11" aria-label="Open menu" style={isHome ? { opacity: contentOpacity } : {}}>
          &#9776;
        </motion.button>
        <motion.img
          src={Logo}
          alt="Logo"
          className="nav-mobile-logo"
          onClick={() => {
            navigate('/');
          }}
          style={
            isHome
              ? {
                  width: 'min(680px, calc(100vw - 32px))',
                  height: 'auto',
                  scale: logoScale,
                  y: logoY,
                  transformOrigin: 'center',
                  opacity: footerLogoOpacity,
                  objectFit: 'contain',
                }
              : {
                  width: '180px',
                  height: 'auto',
                  scale: 1,
                  y: 0,
                  transformOrigin: 'center',
                  opacity: 1,
                  objectFit: 'contain',
                }
          }
        />

        <motion.div className="nav-mobile-actions" style={isHome ? { opacity: contentOpacity } : {}}>
          <button className="nav-mobile-action-btn" onClick={() => navigate('/cart')} aria-label="Cart" type="button">
            <ShoppingBag size={22} className="text-white" />
          </button>
          <button className="nav-mobile-action-btn" onClick={accountClick} aria-label="Account" type="button">
            {getState() ? <User size={24} className="text-white" /> : <LogIn size={24} className="text-white" />}
          </button>
        </motion.div>
      </div>
    </div>
  );
}
